module.exports = __webpack_public_path__ + "img/buscar.1f3fd46a.png";